import Vue from 'vue'
import {NavBar, Button, Icon, Tab, Tabs, Search, Grid, GridItem, Image, Cell, CellGroup, Badge, Picker, Popup, Field, Uploader, Divider, Toast, List, Empty, DropdownMenu, DropdownItem, Collapse, CollapseItem, Loading } from 'vant'

Vue.use(NavBar)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Search)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Image)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Badge)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(Field)
Vue.use(Uploader)
Vue.use(Divider)
Vue.use(Toast)
Vue.use(List)
Vue.use(Empty)
Vue.use(Image)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Loading)

